/* eslint-disable @typescript-eslint/no-non-null-assertion */
import axios from 'axios';

import { getAccessToken } from '../utils/portal-token.util';

const defaultHeaders = {
  'Access-Control-Allow-Origin': '*',
  Authorization: `Bearer ${getAccessToken()}`,
  client_id: process.env.REACT_APP_SENSEDIA_CLIENT_ID || '',
  'Content-Type': 'application/json;charset=utf-8'
};

export const apiSensediaSegmentacao = axios.create({
  baseURL: process.env.REACT_APP_API_SENSEDIA_SEGMENTACAO_URL,
  headers: { ...defaultHeaders, newendpoint: true },
  transformRequest: [
    function (data, headers) {
      headers!['Authorization'] = `Bearer ${getAccessToken()}`;
      return JSON.stringify(data);
    }
  ]
});
